export const messages = {
  en: {
    couponPropertyUser: {
      scanPlaceholder: 'Please scan with barcode scanner',
      verify: 'Verify',
      verifyResult: 'Verification Result',
      verifyTime: 'Verification Time',
      couponName: 'Coupon Name',
      faceValue: 'Face Value',
      userName: 'User Name',
      phone: 'Phone',
      purpose: 'Purpose',
      searchCondition: 'Search Conditions',
      couponNamePlaceholder: 'Please enter coupon name',
      userNamePlaceholder: 'Please enter user name',
      phonePlaceholder: 'Please enter phone number',
      usageRecord: 'Coupon Usage Records',
      serialNumber: 'No.',
      usageTime: 'Usage Time',
      scanTip: 'Please scan first',
      verifySuccess: 'Verification successful',
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    couponPropertyUser: {
      scanPlaceholder: '请扫码枪扫码核销',
      verify: '核销',
      verifyResult: '核销结果',
      verifyTime: '核销时间',
      couponName: '优惠券名称',
      faceValue: '面值',
      userName: '用户名称',
      phone: '手机号',
      purpose: '用途',
      searchCondition: '查询条件',
      couponNamePlaceholder: '请填写优惠券名称',
      userNamePlaceholder: '请填写用户名称',
      phonePlaceholder: '请填写手机号',
      usageRecord: '优惠券使用记录',
      serialNumber: '编号',
      usageTime: '使用时间',
      scanTip: '请先扫码',
      verifySuccess: '核销成功',
fetchError: '獲取數據失敗'
    }
  },
  'zh-TW': {
    couponPropertyUser: {
      scanPlaceholder: '請扫码槍掃碼核銷',
      verify: '核銷',
      verifyResult: '核銷結果',
      verifyTime: '核銷時間',
      couponName: '優惠券名稱',
      faceValue: '面值',
      userName: '用戶名稱',
      phone: '手機號',
      purpose: '用途',
      searchCondition: '查詢條件',
      couponNamePlaceholder: '請填寫優惠券名稱',
      userNamePlaceholder: '請填寫用戶名稱',
      phonePlaceholder: '請填寫手機號',
      usageRecord: '優惠券使用記錄',
      serialNumber: '編號',
      usageTime: '使用時間',
      scanTip: '請先掃碼',
      verifySuccess: '核銷成功',
      fetchError: '獲取數據失敗'
    }
  }
}